import apiClient from '@/api/client';

export const InternalRoleService = {
    async getAll(): Promise<InternalRoleResponse> {
        const response = await apiClient.get<InternalRoleResponse>('/internal/roles');
        const result = response.data

        if (!result) {
            throw new Error('Failed to retrieve roles.');
        }

        return result;
      }
}

export interface InternalRoleResponse {
    roles: string[]
}